// PACKAGES
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
// APP
import { formatBytes } from 'src/app/_utils/utils';
import { FileInfo } from 'src/app/dashboard/file-explorer-page/file-explorer-page.types';
import { FileExplorerStateService } from 'src/app/_state/file-explorer/file-explorer-state.service';
import { MEDIA_IMPORT_STATUS_LABELS, MediaImport, MediaImportService } from 'src/app/_services/media-import.service';

/** helper class for displaying file info */
class FileAttrMap {
  constructor(details: FileInfo) {
    this.mediaLabel = details.media;
    this.modifyDate = details.modifyDate;
    this.accessDate = details.accessDate;
    this.createDate = details.createDate;
    this.hash = details.hash;
  }
  mediaLabel: string;
  modifyDate: number;
  accessDate: number;
  createDate: number;
  hash: string;
}

@Component({
    selector: 'app-info-panel',
    templateUrl: './info-panel.component.html',
    styleUrls: ['./info-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InfoPanelComponent implements OnInit {
  showContent: boolean = false;
  iconName: string;

  _fileExplorerStateListener: Subscription;

  // details to show in info panel
  title: string;
  type: string;
  size: string;
  //--- BACKUP SPECIFIC ---
  backupDate: any;
  //--- FILE SPECIFIC ---
  fileAttrMap: FileAttrMap = null;
  //--- MEDIA SPECIFIC ---
  /** the exports (imports) the media came from; null when the panel shows something else */
  sourceExports: MediaImport[] = null;
  projectId: string;
  private sourceExportsOf: string;
  readonly statusLabel = MEDIA_IMPORT_STATUS_LABELS;

  constructor(private fileExplorerStateService: FileExplorerStateService, private mediaImportService: MediaImportService) { }

  ngOnInit() {
    this._fileExplorerStateListener = this.fileExplorerStateService.explorerState.subscribe(({ infoPanelContent, activeProject }) => {
      if(infoPanelContent?.type === 'MEDIA') {
        this.loadSourceExports(activeProject?.id, infoPanelContent.id);
      } else {
        this.sourceExports = null;
        this.sourceExportsOf = null;
      }

      if(infoPanelContent === null) {
        this.showContent = false;
        return;
      }

      this.showContent = true;
      this.fileAttrMap = null;
      this.backupDate = null;

      this.title = infoPanelContent.name;
      // a file always has a size row, even when TRACS left the size out
      this.size = infoPanelContent.type === 'FILE' || 'size' in infoPanelContent ?
        formatBytes((infoPanelContent as FileInfo).size) : 'unavailable';
      this.type = this.formatTypeInfo(infoPanelContent.type);

      this.iconName = this.getCorrespondingIcon(infoPanelContent.type);

      if(infoPanelContent.type === 'FILE') {
        this.fileAttrMap = new FileAttrMap(infoPanelContent)
      } else if(infoPanelContent.type === 'BACKUP') {
        this.backupDate = infoPanelContent.backupDate;
      }
    });
  }

  /** Return Icon name based on the content type */
  private getCorrespondingIcon(type: string) {
    switch(type) {
      case 'FILE':
        return 'fa-file';
      case 'DIRECTORY':
        return 'fa-folder';
      default:
        return undefined;
    }
  }

  /** The imports a media came from, once per media (the explorer state changes often) */
  private loadSourceExports(projectId: string, mediaId: string) {
    if(!projectId || this.sourceExportsOf === mediaId) { return; }
    this.projectId = projectId;
    this.sourceExportsOf = mediaId;
    this.sourceExports = null;
    this.mediaImportService.list(projectId, { mediaId, limit: 100, offset: 0 }).subscribe({
      next: ({ imports }) => {
        if(this.sourceExportsOf === mediaId) { this.sourceExports = imports; }
      },
      error: () => this.sourceExports = null,
    });
  }

  private formatTypeInfo(type: string) {
    return type === 'PARENT' ? 'Containing Folder' : type; 
  }

}
